import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { isObject } from 'src/app/utils/is-object';

type OnlineNetworkStatus = 'online';
type OfflineNetworkStatus = 'offline';
export type NetworkStatus = OnlineNetworkStatus | OfflineNetworkStatus;

@Injectable({
  providedIn: 'root'
})
export class IsDeviceOnlineServiceV2 {
  constructor(private readonly _httpClient: HttpClient, private readonly _ngZone: NgZone) {
    this._getInitialNetworkStatus();
  }

  private readonly ONLINE_STATUS_CHECK_API_URL = 'https://api64.ipify.org?format=json';
  private readonly LOCALSTORAGE_LAST_STORED_NETWORK_STATUS_KEY = 'last-stored-network-status';
  private readonly _networkConnectionStatus = new BehaviorSubject<NetworkStatus>(
    this._getLastStoredNetworkConnectionStatus()
  );
  public networkConnectionStatus$ = this._networkConnectionStatus.asObservable();

  get currentNetworkStatus() {
    return this._networkConnectionStatus.getValue();
  }

  private async _getInitialNetworkStatus() {
    try {
      const headers = new HttpHeaders({
        'skip-interceptor': 'true'
      });
      const response = await this._httpClient
        .get(this.ONLINE_STATUS_CHECK_API_URL, { headers })
        .toPromise();
      if (this._checkIfNetworkResponseIsValid(response)) {
        this._networkConnectionStatus.next('online');
      } else {
        this._networkConnectionStatus.next('offline');
      }
    } catch (error) {
      console.error('Error fetching network status:', error);
      this._networkConnectionStatus.next('offline');
    }
  }

  private _getLastStoredNetworkConnectionStatus(): NetworkStatus {
    return localStorage.getItem(this.LOCALSTORAGE_LAST_STORED_NETWORK_STATUS_KEY) === 'online'
      ? 'online'
      : 'offline';
  }

  private _setLastStoredNetworkConnectionStatus(networkConnectionStatus: NetworkStatus): void {
    localStorage.setItem(this.LOCALSTORAGE_LAST_STORED_NETWORK_STATUS_KEY, networkConnectionStatus);
  }

  private _checkIfNetworkResponseIsValid(response: unknown): boolean {
    return isObject(response) && 'ip' in response ? true : false;
  }
}
